
<div class="aller-cntr" (click)="this.getAllert()" *ngIf="showAllert">

  <mat-icon>warning</mat-icon>

</div>